import React, { Fragment } from 'react';

import FeaturedPartners from '../components/AllPartners/FeaturedPartners';
import FilterPartners from '../components/AllPartners/FilterPartners';
import BreadCrumbs from '../components/BreadCrumbs';
import { Contain } from '../components/Grid';
import Image from '../components/Image';
import SeoHead from '../components/SeoHead';
import allPartnersBanner from '../public/static/img/pages/all-partners-banner.jpg';
import { getFeaturedPartners } from '../services/api';
import withErrorHandling from '../utils/withErrorHandling';

import ErrorPage from './_error';

const AllPartners = ({ featured, error }) => {
  const routes = {
    prev: [{ url: '/all-partners', name: 'Shop with Our Partners' }],
    curr: { name: 'All Partners' },
  };

  if (error) {
    return <ErrorPage error={error} />;
  }

  return (
    <Fragment>
      <Contain noPadding={true}>
        <SeoHead
          title="Discover All Partners | Link Rewards"
          description="Plus! is now Link. Enjoy exclusive membership privileges and savings when you earn and redeem Linkpoints at over 1000 partners’ outlets in Singapore."
        />
        <Image
          src={allPartnersBanner}
          alt="Linkpoints exchange. Convert Linkpoints to your preferred loyalty points or miles."
          sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw,33vw"
          priority="true"
        />
      </Contain>
      <Contain>
        <BreadCrumbs routes={routes} />
        <FeaturedPartners featured={featured.list} />
        <FilterPartners filters={featured.filters} />
      </Contain>
    </Fragment>
  );
};

const getFeaturedPartnersData = async () => {
  const featured = await getFeaturedPartners();
  return {
    props: {
      featured,
    },
  };
};

export const getServerSideProps = withErrorHandling(getFeaturedPartnersData);

export default AllPartners;
